"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});
Object.defineProperty(exports, "unstable_StrictModeGrow", {
  enumerable: true,
  get: function get() {
    return _StrictModeGrow.default;
  }
});

var _Grow = _interopRequireDefault(require("./Grow"));

var _StrictModeGrow = _interopRequireDefault(require("./StrictModeGrow"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Grow/index.js
// module id = 80
// module chunks = 0